import { useServerTable } from '../../components/common/tables/useServerTable';
import { usersTableParams } from './userTableQuery';

export interface UserRow {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  user_type: string;
  is_active: boolean;
  date_joined: string;
  last_login: string | null;
}

const options = {
  endpoint: 'users', resource: 'Users', params: usersTableParams,
  validRow: (value: unknown): value is UserRow => {
    const row = value as UserRow | null;
    return !!row && ['first_name', 'last_name', 'email', 'user_type', 'date_joined'].every(key =>
      typeof row[key as keyof UserRow] === 'string') && typeof row.is_active === 'boolean' && Number.isFinite(Date.parse(row.date_joined)) &&
      (row.last_login === null || (typeof row.last_login === 'string' && Number.isFinite(Date.parse(row.last_login))));
  },
};
export function useUsersTable(enabled: boolean, access?: string | null) {
  return useServerTable(enabled, access, options);
}
